module.exports = __webpack_public_path__ + "img/official1.c472b4d2.png";